import { Center } from "@chakra-ui/react";

export const FollowMutualOnlyIcon = () => {
  return (
    <Center
      w="20px"
      h="20px"
      borderTopRightRadius="4"
      borderBottomLeftRadius="4"
      bg="rgba(102, 102, 102, 0.6);"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
      >
        <path
          d="M5.99984 6.00033C7.47317 6.00033 8.6665 4.80699 8.6665 3.33366C8.6665 1.86033 7.47317 0.666992 5.99984 0.666992C4.5265 0.666992 3.33317 1.86033 3.33317 3.33366C3.33317 4.80699 4.5265 6.00033 5.99984 6.00033ZM5.99984 2.00033C6.73317 2.00033 7.33317 2.60033 7.33317 3.33366C7.33317 4.06699 6.73317 4.66699 5.99984 4.66699C5.2665 4.66699 4.6665 4.06699 4.6665 3.33366C4.6665 2.60033 5.2665 2.00033 5.99984 2.00033ZM10.2598 7.70699C9.13984 7.13366 7.6865 6.66699 5.99984 6.66699C4.31317 6.66699 2.85984 7.13366 1.73984 7.70699C1.07317 8.04699 0.666504 8.73366 0.666504 9.48032V11.3337H11.3332V9.48032C11.3332 8.73366 10.9265 8.04699 10.2598 7.70699ZM9.99984 10.0003H1.99984V9.48032C1.99984 9.22699 2.13317 9.00033 2.3465 8.89366C3.13984 8.48699 4.41984 8.00033 5.99984 8.00033C7.57984 8.00033 8.85984 8.48699 9.65317 8.89366C9.8665 9.00033 9.99984 9.22699 9.99984 9.48032V10.0003Z"
          fill="#FAFAFA"
        />
        <path
          d="M11.2672 7.23476C11.4867 7.56405 12 7.40864 12 7.01287V6.50065H14.75C15.0722 6.50065 15.3333 6.23948 15.3333 5.91732C15.3333 5.59515 15.0722 5.33398 14.75 5.33398H11.9345H10.9343C10.5349 5.33398 10.2967 5.77906 10.5182 6.11133L11.2672 7.23476ZM14.0715 2.50279C13.8575 2.16384 13.3333 2.3155 13.3333 2.71639V3.33398H10.5833C10.2612 3.33398 10 3.59515 10 3.91732C10 4.23948 10.2612 4.50065 10.5833 4.50065H13.3988H14.4262C14.8199 4.50065 15.0592 4.06659 14.8489 3.73365L14.0715 2.50279Z"
          fill="#EBEDF1"
        />
      </svg>
    </Center>
  );
};
